import React, { useState } from "react";
import SchemaSection from "./SchemaSection";
import FormGenerator from "./FormGenerator";

const SchemasInterpretor = ({
  leftSchema,
  rightSchema,
  leftTitle = "Schéma Gauche",
  rightTitle = "Schéma Droite",
}) => {
  const initializeCheckedAttributes = () => {
    const initialChecked = {};

    Object.entries(leftSchema).forEach(([schemaName, schema]) => {
      const requiredFields = schema.required || [];
      requiredFields.forEach((fieldName) => {
        initialChecked[`${schemaName}/${fieldName}`] = true;
      });
    });

    return initialChecked;
  };

  const [connections, setConnections] = useState([]);
  const [activeConnection, setActiveConnection] = useState(null);
  const [checkedAttributes, setCheckedAttributes] = useState(
    initializeCheckedAttributes()
  );
  const [comments, setComments] = useState({});

  console.log("connections", connections);
  // Convertir les connexions en format JSON simplifié

  const handleConnect = (id, buttonElement, side) => {
    if (side === "left") {
      setActiveConnection({ start: id, startElement: buttonElement });
    } else if (side === "right" && activeConnection) {
      // Vérifier si l'élément de droite n'est pas déjà connecté
      const isEndAlreadyConnected = connections.some(
        (conn) => conn.endName === id
      );
      if (!isEndAlreadyConnected) {
        setConnections((prev) => [
          ...prev,
          {
            start: activeConnection.startElement,
            end: buttonElement,
            startName: activeConnection.start,
            endName: id,
          },
        ]);
        setActiveConnection(null);
      }
    }
  };

  const handleRemoveConnection = (connectionToRemove) => {
    setConnections((prev) =>
      prev.filter(
        (conn) =>
          !(
            conn.startName === connectionToRemove.startName &&
            conn.endName === connectionToRemove.endName
          )
      )
    );
  };

  const handleCheckAttribute = (attributeId, isChecked) => {
    setCheckedAttributes((prev) => ({
      ...prev,
      [attributeId]: isChecked,
    }));
    // Si l'attribut est décoché, supprimer son commentaire
    if (!isChecked) {
      setComments((prev) => {
        const newComments = { ...prev };
        delete newComments[attributeId];
        return newComments;
      });
    }
  };

  const handleCommentChange = (attributeId, comment) => {
    setComments((prev) => ({
      ...prev,
      [attributeId]: comment,
    }));
  };

  const generateFilteredSchema = () => {
    const filteredSchema = {};

    Object.entries(leftSchema).forEach(([schemaName, schema]) => {
      const filteredProperties = {};
      const requiredFields = [];

      Object.entries(schema.properties || {}).forEach(
        ([propName, propValue]) => {
          const attributeId = `${schemaName}/${propName}`;
          if (checkedAttributes[attributeId]) {
            // Copie de la propriété
            const propertyWithConnection = { ...propValue };

            // Recherche des connexions pour cette propriété
            const propertyConnections = connections.filter(
              (conn) => conn.startName === attributeId
            );

            // Si des connexions existent, ajout des connexions dans un tableau
            if (propertyConnections.length > 0) {
              propertyWithConnection.connections = propertyConnections.map(
                (conn) => {
                  const [targetSchema, targetProp] = conn.endName.split("/");
                  return {
                    schema: targetSchema,
                    property: targetProp,
                  };
                }
              );
            }

            // Ajout du commentaire s'il existe
            const comment = comments[attributeId];
            if (comment) {
              propertyWithConnection.comment = comment;
            }

            filteredProperties[propName] = propertyWithConnection;
            if (schema.required?.includes(propName)) {
              requiredFields.push(propName);
            }
          }
        }
      );

      if (Object.keys(filteredProperties).length > 0) {
        filteredSchema[schemaName] = {
          type: "object",
          properties: filteredProperties,
          ...(requiredFields.length > 0 && { required: requiredFields }),
        };
      }
    });

    return filteredSchema;
  };

  const filteredSchema = generateFilteredSchema();
  const hasCheckedAttributes = Object.values(checkedAttributes).some(
    (value) => value
  );

  return (
    <div className="container-fluid px-0 py-4">
      <div className="row">
        <div
          className="col-6"
          style={{
            background: "#b9b9b9",
          }}
        >
          <div className="">
            <h2 className="h4 my-2 text-white">{leftTitle}</h2>
            <div
              style={{
                maxHeight: "95vh",
                overflow: "auto",
              }}
            >
              {Object.entries(leftSchema).map(([schemaName, schema]) => (
                <SchemaSection
                  key={schemaName}
                  title={schemaName}
                  schema={schema}
                  side="left"
                  onConnect={(id, element) =>
                    handleConnect(id, element, "left")
                  }
                  onRemoveConnection={handleRemoveConnection}
                  connections={connections}
                  rightSchema={rightSchema}
                  activeConnection={activeConnection}
                  checkedAttributes={checkedAttributes}
                  onCheckAttribute={handleCheckAttribute}
                  comments={comments}
                  onCommentChange={handleCommentChange}
                />
              ))}
            </div>
          </div>
        </div>

        <div
          className="col-6"
          style={{
            background: "#b9b9b9",
          }}
        >
          <div className="">
            <h2 className="h4 my-2 text-white">{rightTitle}</h2>
            <div
              style={{
                maxHeight: "95vh",
                overflow: "auto",
              }}
            >
              {Object.entries(rightSchema).map(([schemaName, schema]) => (
                <SchemaSection
                  key={schemaName}
                  title={schemaName}
                  schema={schema}
                  side="right"
                  onConnect={(id, element) =>
                    handleConnect(id, element, "right")
                  }
                  onRemoveConnection={handleRemoveConnection}
                  connections={connections}
                  rightSchema={rightSchema}
                  activeConnection={activeConnection}
                  checkedAttributes={checkedAttributes}
                  onCheckAttribute={handleCheckAttribute}
                  comments={comments}
                  onCommentChange={handleCommentChange}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {hasCheckedAttributes && (
        <div className="row mt-4">
          <div className="col-12">
            <div className="border rounded p-3">
              <h3 className="h4 mb-3">Schéma Filtré</h3>
              <textarea
                className="form-control"
                value={JSON.stringify(filteredSchema, null, 2)}
                rows={10}
                readOnly
              />
              <FormGenerator schema={filteredSchema} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SchemasInterpretor;
